import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "sonner";

import { useAuth, isSuperadminRole } from "@/lib/auth/AuthContext";

// Business-Routen-Gate (Daniel-Direktive 2026-07-12: „Ich als Superadmin will
// nichts business-maessiges sehen."). Wraps als Layout-Route die komplette
// Business-Route-Gruppe (ADMIN_NAV ohne Home: /kunden, /projekte, /leads,
// /rechnungen, /finanzen, /verdienst, /produkte, /team samt Detail-/Unter-
// routen). Bisher war nur die Superadmin-NAV auf Home reduziert — die Routen
// selbst rendern aber weiter, wenn der Superadmin direkt hin-navigiert
// (URL-Eingabe, Deep-Link, Such-Palette).
//
// WICHTIG — Impersonation-Nuance: Der Guard greift auf die EFFEKTIVE Rolle.
// Sobald der Superadmin impersoniert, liefert `/api/me` (withAuth ueberschreibt
// req.user mit dem Ziel-User) die Ziel-Rolle — `user.role` ist dann
// admin/pl/buchhaltung und die Business-Route rendert ganz normal. Nur der
// UN-impersonierte Superadmin (effektive Rolle === superadmin — dasselbe
// Signal, das SUPERADMIN_NAV liefert) wird freundlich auf den Kommandostand
// umgeleitet.
//
// Reine UI-/Routing-Schranke — KEINE Aenderung an RLS/Service-Layer. Der
// Superadmin behaelt technisch vollen Zugriff via Impersonation; die
// Datensicherheit bleibt unveraendert.
const IMPERSONATE_HINT =
  "Operative Sichten erreichst du über Impersonation — wähle oben eine Rolle.";

export function RequireOperatingRole() {
  const { status, user } = useAuth();
  const blocked =
    status === "signed-in" && !!user && isSuperadminRole(user.role);

  // Freundlicher Hinweis statt hartem 403. Stabile Toast-ID → sonner de-dupet,
  // damit Re-Renders keinen Stapel erzeugen.
  useEffect(() => {
    if (blocked) {
      toast.info(IMPERSONATE_HINT, { id: "superadmin-business-redirect" });
    }
  }, [blocked]);

  // Loading-State respektieren (analog RequireSuperadmin/-Admin): ein Tick
  // „superadmin" waehrend AuthContext noch laedt darf nicht faelschlich
  // umleiten.
  if (status === "loading") return null;
  if (blocked) return <Navigate to="/" replace />;
  return <Outlet />;
}
